import { Link } from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import Underline from '@tiptap/extension-underline';
import { generateHTML } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import cx from 'classnames';
import { useEffect, useState } from 'react';
import css from './RichTextDisplay.module.scss';

export interface IRichTextDisplayProps {
  className?: string;
  content: string;
}

export const RichTextDisplay = ({
  className,
  content,
}: IRichTextDisplayProps) => {
  const [html, setHtml] = useState<string>(undefined);

  // generateHTML uses window and will not render on
  // the server so this has to be done in an effect
  useEffect(() => {
    setHtml(
      content
        ? generateHTML(JSON.parse(content), [
            StarterKit,
            Link,
            TextAlign.configure({
              types: ['paragraph', 'heading'],
              alignments: ['left', 'center', 'right'],
              defaultAlignment: 'left',
            }),
            Underline,
          ])
        : undefined
    );
  }, [content]);

  return (
    <p
      className={cx(css.richTextDisplay, className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
